import React, {Component} from 'react';
import yes_btn from './yes_btn.png';
import no_btn from './no_btn.png';
import { connect } from 'react-redux';
import * as actions from '../../constants/actions';
import './IdentityConfirmation.css';
import URLS from '../../constants/urls';
import { getEnvironmentFromUrl } from '../../services/network';
import decode from 'jwt-decode';
import { signout } from '../../services/oidc';

const mapStateToProps = state => ({
    tokenData: state.app.tokenData,
    idTokenData: state.app.idTokenData,
    studentName: state.app.studentName,
    studentSiteCode: state.app.studentSiteCode
});

const mapDispatchToProps = dispatch => ({
    onIdentityConfirmation: () => dispatch({ type: actions.APP_IDENTITY_CONFIRMED}),
    onIdentityDenied: () => dispatch({type: actions.APP_IDENTITY_DENIED}),
    onStudentName: (studentName) => dispatch({type: actions.APP_STUDENT_NAME, payload: studentName}),
    onStudentSiteCode: (siteCode) => dispatch({type: actions.APP_STUDENT_SITECODE, payload: siteCode}),
    clearPreviouslyStoredQueryParameters: () => dispatch({type: actions.APP_CLEAR_STORED_QUERY_PARAMS})
});

export class IdentityConfirmation extends Component
{
    constructor(props){
        super(props);
        var token = this.props.tokenData;
        if (token != null){
            var decodedString = decode(token);
            this.props.onStudentName(decodedString['given_name']);
            let sitecodes = decodedString['http://il/sites'];
            this.props.onStudentSiteCode(sitecodes.split(',')[0]);
        }else{
            this.props.onStudentName("Student Data Not Found");
        }

        this.handleIdentityDenied = this.handleIdentityDenied.bind(this);
    }

    handleIdentityDenied(imlp) {
        let environment = getEnvironmentFromUrl(window.location.toString(), window.location.search);
        this.props.clearPreviouslyStoredQueryParameters(); // We should assume previous query parameters were incorrect.

        if (!imlp)
        {
            let signoutUrl = "";
            if(this.props.idTokenData !== null){
                const auth =  URLS[environment].auth;
                const signinUrl = URLS[environment].signin;
                signoutUrl = auth + "/connect/endsession?id_token_hint=" + this.props.idTokenData + "&post_logout_redirect_uri=" + signinUrl;
            } else {
                signoutUrl = URLS[environment].signoutPage;
            }

            console.log(signoutUrl);
            window.location.replace(signoutUrl);
        }else{
            this.props.onIdentityDenied();
            signout().catch((error) => console.error(error));
        }
    }

    componentDidMount() {
        window.document.title = 'Confirming User | Imagine Learning';
    }

    render ()
    {
        return (
            <div className="confirm-background">
                <h3 className="text-title">Is your name <span className="text-user">{this.props.studentName}</span>?</h3>
                <div className="bottom">
                    <div className="image-background"><img className="image-link" alt='Yes' onClick= {(e) => {this.props.onIdentityConfirmation()}} src={yes_btn} /></div>
                    <div className="image-background"><img className="image-link" alt='No' onClick= {(e) => {this.handleIdentityDenied(this.props.imlp)}} src={no_btn} />   </div>               
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(IdentityConfirmation);


// WEBPACK FOOTER //
// ./src/components/IdentityConfirmation/IdentityConfirmation.js